import { AppDispatch, ThunkExtraArguments } from "../store";
import {
  getRewardAmountsByStatus,
  GetRewardAmountsByStatusResponse,
} from "../../api/graphQl/authenticated";
import { setRewards, setRewardsLoading } from "../reducers/rewards";

export const loadRewards =
  (brandIds?: number[]) =>
  async (
    dispatch: AppDispatch,
    _getState: unknown,
    { apolloClient }: ThunkExtraArguments
  ) => {
    try {
      dispatch(setRewardsLoading(true));
      const { data } =
        await apolloClient.query<GetRewardAmountsByStatusResponse>({
          query: getRewardAmountsByStatus,
          fetchPolicy: "no-cache",
          variables: {
            forceRefresh: true,
            brandIds,
          },
        });
      if (data) {
        dispatch(setRewards(data.RewardSummary));
        return data.RewardSummary;
      }
    } catch (e) {
      console.error("loadRewards error: ", e);
    } finally {
      dispatch(setRewardsLoading(false));
    }
  };
